import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import LazyImage from 'components/display/LazyImage'
import MediaWrapper from 'components/cards/shared/MediaWrapper'
import SimpleA from 'components/display/SimpleAnchor'
import { PlaceholderCardWrapper } from 'components/cards/PlaceholderCard'

const Placeholder = styled(PlaceholderCardWrapper)``

export const LoadingPlaceholder = () => (
  <Placeholder>
    <MediaWrapper portrait rounded />
  </Placeholder>
)

const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(
    180deg,
    rgba(29, 29, 29, 0) 52.58%,
    #1d1d1d 106.07%
  );
`

const TruncatedP = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

const MarketsOuter = styled(TruncatedP)`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  font-weight: 300;
  line-height: 1.4;
  margin: 0;
`

type Market = {
  id: string
  code: string
  name: string
}

const Markets = ({ markets }: { markets: Market[] }) => {
  if (!markets) {
    return null
  }

  const formatted = markets?.map(({ name }) => name)?.join(' • ')

  return <MarketsOuter>{formatted}</MarketsOuter>
}

const Name = styled(TruncatedP)`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};
  font-weight: 400;
  line-height: 1.3;
  margin: 0;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-lg']?.['font-size']?.value};
  `}
`

const Info = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 24px;

  color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
`

type Props = {
  name: string
  slug: string
  image?: {
    medium: string
    large: string
  }
  markets?: Market[]
}

const CollectionCard = ({ name, slug, image, markets }: Props) => {
  const href = `/collections/${slug}`

  return (
    <SimpleA href={href} target="_blank" rel="noopener noreferrer">
      <MediaWrapper portrait>
        <LazyImage
          data-srcset={`
          ${image?.medium} 620w,
          ${image?.large} 1200w,
        `}
          data-src={image?.large}
          rounded
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
          }}
        />
        <Overlay />
        <Info>
          <Markets markets={markets} />
          <Name>{name}</Name>
        </Info>
      </MediaWrapper>
    </SimpleA>
  )
}

export default CollectionCard
